import { useState } from 'react';
import { useAuth } from '../components/AuthContext';
import { BUILD } from '../lib/supabase';
import { OnHandLogo } from '../components/brand/OnHandLogo';

/*
  Signed in, and OnHand could not load your account.

  **This screen exists because of what its absence cost.** On 7 September 2026
  the owner reported five or six times that he typed his email and password and
  nothing happened: the sign-in screen just came back. Every one of those
  attempts had SUCCEEDED. Supabase had said yes each time. What failed was the
  step afterwards, reading his own record, and the app's answer to that was to
  show the sign-in screen again and say nothing at all.

  **So the only conclusion available to him was that his password was wrong.** It
  never was. A screen that says what happened would have turned an hour of
  guessing into one sentence.

  Rule 35: the app itself is not standing here, so there is no shell. Rule 24 for
  the same reason.
*/
export default function SignedInButStuck({ user }) {
  const { signOut } = useAuth();
  const [busy, setBusy] = useState(false);

  async function again() {
    setBusy(true);
    // The cheapest thing that fixes a session the browser could not hold on to,
    // and the same thing a person would try: load the page again.
    window.location.reload();
  }

  return (
    <div className="login-page">
      <div style={{
        maxWidth: 440, margin: '0 auto', padding: '32px 30px',
        background: 'var(--surface-card)', borderRadius: 'var(--oh-radius-card)', boxShadow: 'var(--depth-rest)',
      }}>
        <OnHandLogo iconSize={40} />
        <div className="oh-title" style={{ fontSize: 19, fontWeight: 800, color: 'var(--text-strong)', marginTop: 22 }}>
          You are signed in, but OnHand could not load your account
        </div>
        <div style={{
          marginTop: 14, borderRadius: 12, padding: '13px 15px', fontSize: 13, lineHeight: 1.6,
          background: 'var(--warning-bg)', color: 'var(--warning-ink)',
        }}>
          Your email and password were right. The step after them did not finish,
          so there is nothing to show you yet. This is not something you did.
        </div>
        <div style={{ marginTop: 16, fontSize: 13, lineHeight: 1.65, color: 'var(--text-secondary)' }}>
          Signed in as <b>{user?.email}</b>. Try again first. If it happens twice,
          sign out and back in, and tell whoever looks after OnHand what this
          screen says, including the build below.
        </div>
        <div className="btn-row" style={{ marginTop: 20 }}>
          <button className="btn btn-primary" onClick={again} disabled={busy}>
            {busy ? 'Trying...' : 'Try again'}
          </button>
          <button className="btn btn-quiet" onClick={() => signOut()} disabled={busy}>
            Sign out
          </button>
        </div>
        <div style={{ marginTop: 18, fontSize: 11, color: 'var(--text-secondary)' }}>
          Build {BUILD}
        </div>
      </div>
    </div>
  );
}
